/** @module AQL/Workflow/InspectionReopen */
define([
	"dojo/_base/declare",
	"csi/def/Action",
	"csi/xml"
], function(declare,Action,xml) {

	return declare(Action, {
		/**
		 * @override
		 * C8-27756: Final Inspection 7.3 Model changes - State Model - Enable two workflows
		 * ignore frozen flag when checking access
		 */
		checkNodeAccess: function(node, ctx) {
			return xml.nodeHasRight(node, this.m_right) && !xml.nodeHasFlag(node, xml.NODE_FLAG_NOEDIT);
		}
	});
});